/**
 * 全仓加载/进行中文案常量。
 *
 * 规则：
 * - 进行中状态统一使用中文省略号 "…"（U+2026），禁止 ASCII 三点 "..."
 * - 与状态枚举对齐的（importing / transcoding / analyzing 等）不带省略号，因为它们在 status badge 中也复用
 * - UI 层禁止硬编码 "X中..." 字符串，统一从此处导入
 */
export const LOADING_LABELS = {
	// === 通用 ===
	loading: "加载中…",
	saving: "保存中…",
	submitting: "提交中…",
	creating: "创建中…",
	deleting: "删除中…",
	updating: "更新中…",
	processing: "处理中…",
	refreshing: "刷新中…",
	fetching: "拉取中…",
	syncing: "同步中…",
	connecting: "连接中…",
	computing: "计算中…",
	starting: "启动中…",

	// === 上传 / 下载 ===
	uploading: "上传中…",
	downloading: "下载中…",

	// === 与 MaterialStatus 对齐（无省略号，状态枚举专用） ===
	importing: "导入中",
	transcoding: "转码中",
	analyzing: "分析中",

	// === 媒体处理 ===
	transcribing: "转写中…",
	generating: "生成中…",
	rendering: "渲染中…",

	// === 用户认证 / 通信 ===
	signingIn: "登录中…",
	registering: "注册中…",
	validating: "验证中…",
	sending: "发送中…",

	// === AI 对话 ===
	thinking: "思考中…",
	chatting: "对话中…",
} as const;

export type LoadingLabelKey = keyof typeof LOADING_LABELS;
